type StatusTone = "positive" | "attention" | "neutral";

type StatusBadgeProps = {
  label: string;
  tone?: StatusTone;
};

export function StatusBadge({ label, tone = "neutral" }: StatusBadgeProps) {
  return <span className={`ui-status-badge ${tone}`}>{label}</span>;
}
